import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
//Limitless imports
import { LoginButton } from "@limitless/portal";
import SectionHeader from "../section-header/SectionHeader";
import ClosedOverlay from "../closed-overlay/ClosedOverlay";
import { formatToTimeZone } from "@limitless/common/utils";
import { generalSubHeaderStyles } from "../example-questions/ExampleQuestions";
const useStyles = makeStyles(theme => ({
  ...generalSubHeaderStyles(theme),
  signUpContentContainer: {
    marginTop: 8,
    paddingBottom: 24,
    textAlign: "center"
  },
  contentContainer: {
    paddingBottom: "4%"
  },
  buttonContainer: {
    paddingLeft: 0
  },
  buttonWidth: {
    width: 284,
    margin: "auto",
    display: "flex",
    justifyContent: "center"
  },
  [theme.breakpoints.up("sm")]: {
    signUpContentContainer: {
      textAlign: "left"
    },
    buttonWidth: {
      width: 234
    }
  },
  [theme.breakpoints.up("md")]: {
    buttonContainer: {
      paddingLeft: 90
    },
    buttonWidth: {
      margin: 0,
      justifyContent: "flex-start"
    }
  },
  [theme.breakpoints.up("lg")]: {
    buttonWidth: {
      width: 213
    }
  }
}));

// LD-16578/LD-15665 — the redirect below leaves this campaign's landing URL, so carry its utm_*
// tags over to the generic group's page; without them captureRegistrationUrl stores a bare URL there
// and the sign-up is attributed to nothing. Only utm_* travels, matching the data minimisation
// minimizeRegistrationUrl applies (a raw query can carry referral tokens or emails).
const utmQueryString = () => {
  try {
    const utm = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (key.toLowerCase().startsWith("utm_")) {
        utm.append(key, value);
      }
    });
    const query = utm.toString();
    return query ? `?${query}` : "";
  } catch (e) {
    return "";
  }
};
const SignUpCta = ({
  content,
  endDate,
  hash,
  genericGroupHash,
  leftSpaceContainer
}) => {
  const classes = useStyles();
  const [showClosedDailog, setShowClosedDailog] = React.useState(false);

  // LD-16578 — a closed campaign sends its Sign Up CTA to the generic "Introduction to Limitless"
  // group instead of its own (now pointless) sign-up form. genericGroupHash is per-environment, so
  // it arrives as a prop from the onboard app rather than being read here: this library is also
  // bundled into crowd-manager and expert-web-app, which build from their own env. When it is
  // absent we fall through to the pre-existing behaviour rather than navigating to "/undefined".
  const handleSignUpButtonClick = () => {
    const currentDate = Date.parse(new Date());
    const isClosed = Boolean(endDate) && endDate <= currentDate;
    const redirectToGenericGroup = isClosed && Boolean(genericGroupHash) && hash !== genericGroupHash;
    if (isClosed && !showClosedDailog) {
      setShowClosedDailog(true);
      content.closedSubHeader = content.closedSubHeader.replaceAll("<Onboarding campaign closed date>", formatToTimeZone(endDate, "DD/MM/YYYY HH:mm"));
    } else if (redirectToGenericGroup) {
      window.location.assign(`/${genericGroupHash}${utmQueryString()}`);
    } else if (typeof endDate !== "undefined") {
      window.location.assign(`${hash}/signup`);
    }
  };
  return /*#__PURE__*/React.createElement(Grid, {
    className: leftSpaceContainer
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header
  }), /*#__PURE__*/React.createElement(Grid, {
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.generalSubHeaderContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textPrimary",
    className: classes.signUpContentContainer
  }, content.subHeader)), /*#__PURE__*/React.createElement(Grid, {
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(LoginButton, {
    onClick: handleSignUpButtonClick,
    containerClasses: classes.buttonWidth
  }, content.buttonLabel))), /*#__PURE__*/React.createElement(ClosedOverlay, {
    content: content,
    open: showClosedDailog,
    handleCloseDailogClick: () => setShowClosedDailog(false),
    handleSignUpButtonClick: handleSignUpButtonClick
  }));
};
SignUpCta.propTypes = {
  content: PropTypes.object.isRequired,
  hash: PropTypes.string,
  endDate: PropTypes.number,
  genericGroupHash: PropTypes.string,
  leftSpaceContainer: PropTypes.string
};
export default SignUpCta;